export default function validateUserAddressNameInput(name: string) {
  const expected = ['countryCode', 'city', 'line1', 'postalCode'];
  return expected.includes(name);
}
